const popupHover = {
    userBtn: document.getElementById('jsUserBtn') as HTMLElement,
    cartBtn: document.getElementById('jsCartBtn') as HTMLElement,
    userWrap: document.getElementById('jsUserWrap') as HTMLElement,
    cartWrap: document.getElementById('jsCartWrap') as HTMLElement,
    

    init() {
        this.userHover();
        this.cartHover();
        this.checkHoverState();
    },


    userHover() {
        this.userBtn.addEventListener('mouseenter', (e) => {
            this.userWrap.classList.add('activeClass');

        }) 

        // this.userBtn.addEventListener('mouseleave', (e) => {
        //     this.userWrap.classList.remove('activeClass');

        // }) 

    },


    cartHover() {
        this.cartBtn.addEventListener('mouseenter', () => {
            this.cartWrap.classList.add('activeClass');
        }) 

        // this.cartBtn.addEventListener('mouseleave', () => {
        //     this.cartWrap.classList.remove('activeClass');
        // }) 

    },



    checkHoverState() {

        window.addEventListener('mouseover', e => {
            const target = e.target as HTMLElement; 

            if(target !== this.userWrap && !this.userWrap.contains(target) && target !== this.userBtn && !this.userBtn.contains(target) && target !== this.cartWrap && !this.cartWrap.contains(target) && target !== this.cartBtn && !this.cartBtn.contains(target)) {
                this.userWrap.classList.remove('activeClass');
                this.cartWrap.classList.remove('activeClass');
            }
        })
    }
}

export default popupHover;


